import React from 'react'
import PropTypes from 'prop-types'
import { withRouter } from 'react-router-dom'
import BreadCrumbs from 'components/shared/bread-crumbs/public'
import PassportPaymentForm from 'forms/client/payment-passport'
import startCase from 'lodash/startCase'
import { Helmet } from 'react-helmet'

const PassportPayment = ({ match }) => {
  const place = match.params.place
  const trails = [
    { title: 'Passport', url: '/passport' },
    { title: `Passport ${startCase(place)}`, url: `/passport/${place}` },
    { title: 'Purchase', url: match.url },
  ]
  return (
    <div className="passport-checkout">
      <Helmet>
        <meta name="robots" content="nofollow" />
        <meta name="googlebot" content="noindex" />
      </Helmet>
      <div className="container mx-auto my-10">
        <div className="mx-10 mb-5">
          <BreadCrumbs trails={trails} />
        </div>
        <PassportPaymentForm {...match.params} />
      </div>
    </div>
  )
}

PassportPayment.propTypes = {
  match: PropTypes.object.isRequired,
}

export default withRouter(PassportPayment)
